<template>
	<div class="data-box">
		<div class="data-content">
			<img src="../assets/images/suvQes/suv_center_no.png" alt="" class="img-inpresive" />
		</div>
		<p class="data-text fsize-15">{{title}}</p>
		
	</div>
</template>
<script>
	export default {
		data() {
			return {}
		},
		props: {
			title: {
				type: String,
				default: '暂无相关信息'
			},
			btnTips: {
				type: String,
				default: '确定'
			},
			
			
		},
		created: function() {
			

		},
		mounted:function() {},
		methods: {}
	}
</script>
<style scoped>
	.data-box {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;	
		margin-top: 50px;
	}
	.data-content {
		width: 150px;
		margin: 10px auto;
	}
	.data-text {
		color: #696969; 
		width: 50%;
		margin: 0 auto;
		text-align: center;
	}
	.data-return{
		margin-top: 20px;
		text-align: center;
	}
	button{
		padding: 10px;
		margin: 40px auto 0;
		display: block;
		min-width: 140px;
		
	}
</style>


// WEBPACK FOOTER //
// src/components/noData.vue